import React from "react";

interface StatusCardProps {
  title: string;
  enabled?: boolean;
  icon: React.ReactNode;
  borderColor: string;
  bgColor: string;
  iconColor: string;
  additionalInfo?: React.ReactNode;
  enabledText?: string;
  disabledText?: string;
}

const StatusCard: React.FC<StatusCardProps> = ({
  title,
  enabled,
  icon,
  borderColor,
  bgColor,
  iconColor,
  additionalInfo,
  enabledText = "Enabled",
  disabledText = "Disabled",
}) => {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-xl border ${borderColor} dark:border-gray-700 p-4 shadow-sm hover:shadow-md transition-shadow`}
    >
      <div className="flex items-start gap-3">
        <div className={`p-2 ${bgColor} rounded-lg flex-shrink-0`}>
          <div className={iconColor}>{icon}</div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
            {title}
          </h3>

          {/* Only render the status pill if 'enabled' is explicitly true or false */}
          {enabled !== undefined && (
            <div className="flex items-center gap-2 mb-2">
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${enabled
                    ? "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300"
                    : "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300"
                  }`}
              >
                {enabled ? enabledText : disabledText}
              </span>
            </div>
          )}

          {/* Show additional info if it exists AND the card isn't explicitly disabled */}
          {additionalInfo && enabled !== false && (
            <div className="mt-2">{additionalInfo}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatusCard;